/*
 * VPDB - Virtual Pinball Database
 * Copyright (C) 2019 freezy <freezy@vpdb.io>
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 * Modified for sigmashake-pinball by SigmaShake, 2026.
 */

import type { ItemFrame } from "../../shared/contracts";

/**
 * The part of an item that changes while the game runs.
 *
 * Upstream the state classes are pooled and diffed for the renderer. Here a
 * state is a plain object. A state that moves implements `toFrame`. The
 * player sends a frame only when it differs from the last one.
 */
export abstract class ItemState {
  public name: string = "";
  public isVisible: boolean = true;

  public getName(): string {
    return this.name;
  }

  /** The render values of this state, or undefined when the item never moves. */
  public toFrame(): ItemFrame | undefined {
    return undefined;
  }
}

/** True when two frames carry the same values. */
export function frameEquals(a: ItemFrame, b: ItemFrame): boolean {
  return (
    a.name === b.name &&
    a.kind === b.kind &&
    a.angle === b.angle &&
    a.offset === b.offset &&
    a.intensity === b.intensity &&
    a.visible === b.visible
  );
}
